'use client'

import styled from 'styled-components'

import theme from '@/src/config/theme'

import Loading from '@/src/shared/ui/loading'
import logoPic from '@/src/shared/assets/media/logo-white.png'
import Logo from '@/src/shared/ui/logo'

export const LoadingPage = ({background}: {background?: string}) => {
  return (
    <Wrapper $background={background} aria-label="page-loading">
      <Container>
        <div>
          <Loading />
        </div>
        <Logo src={logoPic.src} />
      </Container>
    </Wrapper>
  )
}

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  & img {
    max-height: 100px;
    width: auto;
  }
`

const Wrapper = styled.div<{$background?: string}>`
  z-index: 3000;

  background: ${props => props.$background || theme.colors.dark};
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(3px);

  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
`
